import React from "react";
import { BoxProps } from "@material-ui/core/Box";
import HelpText from "components/design-system/molecules/HelpText";
import BackgroundBox from "../../atoms/BackgroundBox";

interface HelpTextCardProps {
  whiteBackground?: boolean;
  oneLineCentered?: boolean;
  noBorder?: boolean;
}

const HelpTextCard: React.FunctionComponent<HelpTextCardProps & BoxProps> = ({ children, ...props }) => {
  return (
    <BackgroundBox whiteBackground={props?.whiteBackground} noBorder={props?.noBorder} {...props}>
      <HelpText oneLineCentered={props.oneLineCentered}>{children}</HelpText>
    </BackgroundBox>
  );
};

export default HelpTextCard;
